export default "__VITE_ASSET__Duo41Rm5__"